/**
 * TrendingBadge — Badge "🔥 Tendance" à afficher sur les produits trending
 *
 * Usage :
 *   <TrendingBadge /> — badge simple
 *   <TrendingBadge tag="blazer oversized" /> — avec le nom de la tendance
 *   <TrendingBadge compact /> — version mini (juste 🔥)
 */
import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

export default function TrendingBadge({ tag, compact = false, style }) {
  if (compact) {
    return (
      <View style={[s.compactBadge, style]}>
        <Text style={s.compactIcon}>★</Text>
      </View>
    );
  }

  return (
    <View style={[s.badge, style]}>
      <Text style={s.label} numberOfLines={1}>
        {tag ? tag.toUpperCase() : 'TENDANCE'}
      </Text>
    </View>
  );
}

const s = StyleSheet.create({
  badge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    backgroundColor: '#FF6B35',
    shadowColor: '#FF6B35',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.3,
    shadowRadius: 4,
    elevation: 3,
    alignSelf: 'flex-start',
  },
  icon: {
    fontSize: 11,
  },
  label: {
    fontSize: 9,
    fontWeight: '800',
    color: '#FFF',
    letterSpacing: 0.5,
  },

  compactBadge: {
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: '#FF6B35',
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: '#FF6B35',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.4,
    shadowRadius: 4,
    elevation: 4,
  },
  compactIcon: {
    fontSize: 14,
  },
});
